var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "13", height: "8", viewBox: "0 0 13 8" }, props),
    React.createElement("path", { fill: "#43C6AC", stroke: "#43C6AC", d: "M9.5 4.31l-3 3.19-3-3.19-3-3.19.3-.3.29-.32 2.7 2.88 2.72 2.88L9.2 3.4 11.93.5l.3.3.28.31-3 3.2z" })
  );
});